import PropTypes from 'prop-types'
import React from 'react'
import { CookiesHelper } from 'SRC/core/cookiesHelper/CookiesHelper'
import { getAds } from '../../../selectors'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import withTranslation from 'next-translate/withTranslation'
import { Item } from '../Item'
import { getProfileLoading, getProfileAdsError, getUserInfo, getProfileAdsQuery } from 'SRC/modules/users/Profile/selectors'
import { Preloader } from 'SRC/ui/Preloader'
import { ErrorNotification } from 'SRC/ui/ErrorNotification'
import { setProfileAdsError, setCurrentStatusForAllAds, setPageForAllAds } from 'SRC/modules/users/Profile/actions'

export class List extends React.PureComponent {
  constructor (props) {
    super(props)

    this.cookies = new CookiesHelper()
    this.ref = React.createRef()
  }

  componentDidMount () {
    setTimeout(() => { window.scrollTo(0, 0) }, 1000);
  }

  hideError = () => {
    this.props.setProfileAdsError('')
  }

  isUserPackageExpired = () => {
    if (this.props.user && this.props.user.packages) {
      const userPackage = this.props.user.packages[0]
      return !userPackage.activated || (userPackage.activated && userPackage.expired)
    }
  }

  showPackageExpiredError = () => {
    const { i18n: { t } } = this.props

    this.props.setProfileAdsError(t('common:adsListPackageExpired'))
  }

  render () {
    const packageExpired = this.isUserPackageExpired()
    const { ads, isLoading, error, i18n: { t } } = this.props

    const unpublishedAds = ads.filter(ad => ad.status === 'Unpublished')
    const publishedAds = ads.filter(ad => ad.status === 'Published')
    const pausedAds = ads.filter(ad => ad.status === 'Paused')
    const rejectedAds = ads.filter(ad => ad.status === 'Rejected')
    const soldAds = ads.filter(ad => ad.status === 'Sold')
    const expiredAds = ads.filter(ad => ad.status === 'Expired')

    const sortedAds = [...unpublishedAds, ...publishedAds, ...pausedAds, ...rejectedAds, ...soldAds, ...expiredAds]

    return (
      <div className='moji-oglasi-content' ref={this.ref}>
        {
          sortedAds.length
            ? sortedAds.map(ad => (
              <Item
                key={ad.id}
                {...ad}
                packageExpired={packageExpired}
                showPackageExpiredError={this.showPackageExpiredError}
              />
            )) : <div className='oglasi-content-text__no-ads-text'>{t('common:noAdsMessage')}</div>
        }
        {isLoading ? <Preloader /> : null}
        <ErrorNotification hideNotification={this.hideError} error={error} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const user = getUserInfo(state)

  return {
    ads: getAds(state),
    isLoading: getProfileLoading(state),
    error: getProfileAdsError(state),
    user,
    query: getProfileAdsQuery(state)
  }
}

List.propTypes = {
  ads: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })).isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  setProfileAdsError: PropTypes.func.isRequired,
  user: PropTypes.shape({
    packages: PropTypes.array.isRequired
  }).isRequired,
  query: PropTypes.shape({
    status: PropTypes.string.isRequired
  }),
  setCurrentStatusForAllAds: PropTypes.func.isRequired,
  setPageForAllAds: PropTypes.func.isRequired
}

List.defaultProps = {
  ads: [],
  isLoading: false
}

const enhance = compose(
  connect(mapStateToProps, {
    setProfileAdsError,
    setCurrentStatusForAllAds,
    setPageForAllAds
  }),
  withTranslation
)

export default enhance(List)
